export const EmployerLiabilityInsuranceQuoteTestData = {
   // --- Business Information ---
   aboutBusiness: 'A small, independent accounting and bookkeeping firm serving local businesses.',
   targetProfession: 'Accountant',
   hasSecondaryTrade: 'No', // Choice: Yes / No
   businessPostCode: 'SW1A 0AA', // UK Postcode
   businessCategory: 'Professional Services', // e.g., Professional Services, Construction, Retail
   policyStartDate: '2025-10-15', // YYYY-MM-DD
   
   // --- Principal Contact Information ---
   title: 'Mr', // Choice: Mr, Ms, Mrs, Dr
   firstName: 'Ebenezer',
   lastName: 'Scrooge',
   isCorrespondenceAddressSameAsBusinessAddress: 'Yes', // Choice: Yes / No
   contactEmail: 'ebenezer.scrooge@acme-accountants.co.uk',
   contactPhone: '02079460000', // e.g., UK local number
   alternatePhoneNumber: '',
   
   // --- Employee & Insurance Details ---
   haveEmployees: 'Yes', // Choice: Yes / No
   numberOfEmployees: 3, // Numeric value
   insurancePaymentType: 'Monthly', // Choice: Annual / Monthly
   
   // --- Operations & Risk Questions ---
   useVanForBusiness: 'No', // Choice: Yes / No
   doneBusinessOutsideUK: 'No', // Choice: Yes / No
   largestFeeIncome: 50000, // Numeric value (e.g., in GBP)
   businessActivities: 'Bookkeeping, tax preparation, and general financial consulting.', // Detailed string
   isMemberOfAcca: 'Yes', // Choice: Yes / No (e.g., Association of Chartered Certified Accountants)
   
   // --- Financial & Industry Specific Risk Questions (Yes/No) ---
   hasDoneNonIntroducerFinancialServiceWork: 'No',
   doesWorkForListedCompanies: 'No',
   hasClientInFinancialServiceSector: 'Yes',
   
   // --- Claims & Dispute History (Yes/No) ---
   hadClaimsOrAskedCompensationInLast5Years: 'No',
   isAwareOfPotentialClaimsAgainstCompany: 'No',
   hasOngoingLegalDispute: 'No',
   hasOngoingDisputeWithEmployees: 'No',
   wasSubjectToDisciplinaryHearing: 'No',
   hadInsuranceCoverTerminated: 'No',
   
   // --- Financial & Criminal History (Yes/No) ---
   hadReceivedCountyCourtJudgmentOnDebt: 'No',
   wasDeclaredBankrupt: 'No',
   wasPartOfCompanyLiquidated: 'No',
   wasConvictedOfNonMotoringCriminalOffense: 'No',
   
   // --- Final Section ---
   addAdditionalComments: 'We have recently transitioned all client records to a cloud-based system (Xero).',
   termsAgreement: 'Yes', // Boolean: true / false
};